import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';

export default function Hero() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20technology%20background%20with%20warm%20orange%20and%20dark%20charcoal%20gradient%2C%20soft%20flowing%20shapes%2C%20modern%20minimalist%20design%2C%20smooth%20curves%2C%20high%20contrast%20organic%20composition%2C%20clean%20aesthetic%2C%20no%20text&width=1600&height=900&seq=hero-bg-wending&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <div className="max-w-3xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5">
            <span className="text-primary-400">{siteInfo.name}</span>
            <br />
            <span className="text-2xl md:text-4xl lg:text-5xl font-medium">正版软件 · 安全下载 · 极速畅快</span>
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto leading-relaxed">
            {siteInfo.description}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/software"
              className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-white font-semibold text-base transition-all duration-200 whitespace-nowrap"
            >
              立即下载
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/category/games"
              className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-white/15 hover:bg-white/25 text-white font-medium text-base backdrop-blur-sm border border-white/20 transition-all duration-200 whitespace-nowrap"
            >
              探索游戏
            </Link>
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}